import { render, staticRenderFns } from "./StepTags.vue?vue&type=template&id=6d1b9428&scoped=true&"
import script from "./StepTags.vue?vue&type=script&lang=js&"
export * from "./StepTags.vue?vue&type=script&lang=js&"
import style0 from "./StepTags.vue?vue&type=style&index=0&id=6d1b9428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b9428",
  null
  
)

export default component.exports